module.exports = __webpack_public_path__ + "static/media/rv-repair_color.5392ff5f.png";